/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_03_Detail_Tournament_2_HeadingInputs */

const en_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynamic ball-flight production`)
};

const es_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producción dinámica de vuelo de bola`)
};

const de_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynamische Ballflugproduktion`)
};

const zh_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`动态打造球路`)
};

const ar_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنتاج ديناميكي لمسار الكرة`)
};

const fr_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Production dynamique de vols de balle`)
};

const vi_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sản xuất đường bóng động`)
};

const sw_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzalishaji wa mruko wa mpira unaobadilika`)
};

const th_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การสร้างวิถีลูกแบบไดนามิก`)
};

const bs_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dinamička proizvodnja leta loptice`)
};

const ja_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダイナミックな弾道づくり`)
};

const ko_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`역동적인 구질 만들기`)
};

const pt_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produção dinâmica da trajetória da bola`)
};

const it_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produzione dinamica del volo di palla`)
};

const sv_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynamiskt skapande av bollflykt`)
};

const nl_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynamische productie van balvlucht`)
};

const da_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynamisk skabelse af boldflugt`)
};

const nb_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynamisk skaping av ballflukt`)
};

const fi_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pallon lennon dynaaminen tuottaminen`)
};

const pl_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynamiczne kształtowanie lotu piłki`)
};

const ru_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Динамичное создание полёта мяча`)
};

const tr_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dinamik top uçuşu üretimi`)
};

const hi_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गतिशील तरीके से गेंद की उड़ान बनाना`)
};

const id_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produksi lintasan bola yang dinamis`)
};

const ms_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penghasilan laluan bola yang dinamik`)
};

const cs_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynamické vytváření letu míče`)
};

const el_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δυναμική παραγωγή τροχιάς μπάλας`)
};

const he_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הפקה דינמית של מעוף הכדור`)
};

const af_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dinamiese balvlugproduksie`)
};

const hu_method_content_step_03_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dinamikus röppálya-előállítás`)
};

/**
* | output |
* | --- |
* | "Dynamic ball-flight production" |
*
* @param {Method_Content_Step_03_Detail_Tournament_2_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_03_detail_tournament_2_heading = /** @type {((inputs?: Method_Content_Step_03_Detail_Tournament_2_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_03_Detail_Tournament_2_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "de") return de_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "zh") return zh_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "ar") return ar_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "fr") return fr_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "vi") return vi_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "sw") return sw_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "th") return th_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "bs") return bs_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "ja") return ja_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "ko") return ko_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "pt") return pt_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "it") return it_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "sv") return sv_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "nl") return nl_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "da") return da_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "nb") return nb_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "fi") return fi_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "pl") return pl_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "ru") return ru_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "tr") return tr_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "hi") return hi_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "id") return id_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "ms") return ms_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "cs") return cs_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "el") return el_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "he") return he_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "af") return af_method_content_step_03_detail_tournament_2_heading(inputs)
	if (locale === "hu") return hu_method_content_step_03_detail_tournament_2_heading(inputs)
	return en_method_content_step_03_detail_tournament_2_heading(inputs)
});